export interface ConversationAttachment {
  id: string;
  fileName: string;
  contentType: string;
  fileSize: number;
  markedFinal: boolean;
  conversationId: string | null;
  createdAt: string;
}

export interface Conversation {
  id: string;
  userId: string;
  userEmail: string | null;
  username: string | null;
  adminComment: boolean;
  commentText: string;
  internal: boolean;
  createdAt: string;
  edited?: boolean;
  attachments: ConversationAttachment[];
  conversationType: ConversationType;
}
export enum ConversationType {
  COMMENT = 'COMMENT',
  NOT_APPLICABLE_REASON = 'NOT_APPLICABLE_REASON',
}
